// Core site configuration & bilingual identity data.
export const SITE_URL = "https://drapostolakopoulou.com";

export const doctor = {
  name: { el: "Δρ. Λουκία Αποστολακοπούλου", en: "Dr. Loukia Apostolakopoulou" },
  shortName: { el: "Δρ. Αποστολακοπούλου", en: "Dr. Apostolakopoulou" },
  role: { el: "Νευρολόγος", en: "Neurologist" },
  credentials: "MD, PhD(c)",
  tagline: {
    el: "Επιληψία · Ηλεκτροεγκεφαλογράφημα · Κεφαλαλγίες",
    en: "Epilepsy · EEG · Headaches",
  },
  license: "6366",
  licenseBody: { el: "Ιατρικός Σύλλογος Αθηνών", en: "Athens Medical Association" },
  phone: "+302106755689",
  phoneDisplay: "210 6755689",
  email: "info@drapostolakopoulou.com",
};

export const socials = {
  instagram: "https://www.instagram.com/dr.loukia.apostolakopoulou/",
  facebook: "https://www.facebook.com/profile.php?id=61584680887264",
  tiktok: "https://www.tiktok.com/@drloukiaapostolakopoulou",
  linkedin: "https://www.linkedin.com/in/loukia-apostolakopoulou-b9893955/",
  orcid: "https://orcid.org/0000-0001-7995-2124",
  doctoranytime: "https://www.doctoranytime.gr/d/Nevrologos/apostolakopoulou-loukia",
  instadoctor: "https://www.instadoctor.gr/doctor/apostolakopoulou-loukia",
  googleBusiness: "https://share.google/3O0ISzH1GO6AMezdf",
};

export const locations = [
  {
    id: "ampelokipoi",
    name: { el: "Αμπελόκηποι — Πλατεία Μαβίλη", en: "Ampelokipoi — Platia Mavili" },
    addressLine: { el: "Αθανασιάδου 3-5, Αθήνα 11521", en: "Athanasiadou 3-5, Athens 11521" },
    floor: { el: "3ος όροφος", en: "3rd floor" },
    landmark: { el: "Πλησίον Ευρωκλινικής", en: "Near Euroclinic" },
    mapsQuery: "Αθανασιάδου 3-5, Αθήνα 11521",
    mapsUrl: "https://maps.app.goo.gl/u1QyVXqa67sKKCHC6",
    mapsEmbedQuery: "Λουκία Αποστολακοπούλου Νευρολόγος - Αμπελόκηποι",
    hours: [
      { day: { el: "Δευτέρα", en: "Monday" }, time: "14:00 – 16:00" },
      { day: { el: "Πέμπτη", en: "Thursday" }, time: "12:00 – 16:00" },
      { day: { el: "Παρασκευή", en: "Friday" }, time: "16:00 – 19:00" },
    ],
    hoursNote: { el: "", en: "" },
    access: {
      el: [
        "Μετρό: Στάση «Αμπελόκηποι» ~80μ · «Μέγαρο Μουσικής» / «Πανόρμου» ~900μ",
        "Λεωφορείο: Στάσεις «Υγειονομικό» / «Στ. Αμπελόκηποι» ~100μ",
      ],
      en: [
        "Metro: Ampelokipoi station ~80m · Megaro Mousikis / Panormou ~900m",
        "Bus: Ygeionomiko / St. Ampelokipoi stops ~100m",
      ],
    },
    parking: [
      { name: "Parking Γαζέτας", address: { el: "Αναστασίου Τσόχα 36, Αθήνα 11521", en: "Anastasiou Tsocha 36, Athens 11521" }, phone: "21 0645 7323", note: { el: "Ώρες 10:00–19:00", en: "Hours 10:00–19:00" } },
      { name: "Στάθμευση με παρκόμετρο", address: { el: "Δήμος Αθηναίων — επί της οδού & γύρω περιοχή", en: "City of Athens — on-street & surrounding area" }, phone: "", note: { el: "", en: "" } },
      { name: "Valet Parking", address: { el: "Δευτ.–Παρ. 07:00–21:00", en: "Mon–Fri 07:00–21:00" }, phone: "6944637505 – 6941561256", note: { el: "", en: "" } },
    ],
  },
  {
    id: "agia-paraskevi",
    name: { el: "Αγία Παρασκευή", en: "Agia Paraskevi" },
    addressLine: { el: "Λ. Μεσογείων 402, 15342", en: "402 Mesogeion Ave, 15342" },
    floor: { el: "1ος όροφος", en: "1st floor" },
    landmark: {
      el: "Εντός του κέντρου αποκατάστασης «Ιατρική Άσκηση»",
      en: "Inside the “Iatriki Askisi” rehabilitation centre",
    },
    mapsQuery: "Λεωφόρος Μεσογείων 402, Αγία Παρασκευή",
    mapsUrl: "https://www.google.com/maps?cid=17043848076591287961",
    mapsEmbedUrl: "https://www.google.com/maps?cid=17043848076591287961&output=embed",
    hours: [
      { day: { el: "Επιλεγμένες Τετάρτες", en: "Selected Wednesdays" }, time: "14:00 – 16:00" },
    ],
    hoursNote: {
      el: "Οι ημερομηνίες ανοίγουν κατόπιν προγραμματισμού. Επικοινωνήστε μαζί μας.",
      en: "Dates open by arrangement. Please contact us.",
    },
    access: {
      el: ["Εντός του κέντρου αποκατάστασης «Ιατρική Άσκηση», 1ος όροφος, επί της Λ. Μεσογείων."],
      en: ["Inside the “Iatriki Askisi” rehabilitation centre, 1st floor, on Mesogeion Avenue."],
    },
    carNote: {
      el: "Με αυτοκίνητο: εύκολη πρόσβαση από τη Λ. Μεσογείων. Διαθέσιμη στάθμευση επί της οδού και σε πάρκινγκ της γύρω περιοχής.",
      en: "By car: easy access from Mesogeion Avenue. On-street parking and nearby lots are available.",
    },
  },
];

export const trust = [
  {
    label: { el: "Salzburg — Epicare", en: "Salzburg — Epicare" },
    note: {
      el: "Ευρωπαϊκό Κέντρο Αναφοράς για την Επιληψία",
      en: "European Reference Network for Epilepsy",
    },
  },
  {
    label: { el: "ILAE · Albert Einstein", en: "ILAE · Albert Einstein" },
    note: {
      el: "Πιστοποίηση Επιληπτολογίας & Προηγμένου ΗΕΓ",
      en: "Epileptology & Advanced EEG certification",
    },
  },
  {
    label: { el: "Affidea NeuraCare", en: "Affidea NeuraCare" },
    note: {
      el: "Υπεύθυνη Εργαστηρίου Ηλεκτροεγκεφαλογραφίας",
      en: "Head of the EEG Laboratory",
    },
  },
  {
    label: { el: "Αιγινήτειο Νοσοκομείο", en: "Eginition Hospital" },
    note: {
      el: "Α΄ Νευρολογική Κλινική ΕΚΠΑ — Ειδικό Ιατρείο Επιληψίας",
      en: "1st Neurology Clinic, Univ. of Athens — Epilepsy Unit",
    },
  },
];

export const IMAGES = {
  heroTexture:
    "https://images.unsplash.com/photo-1716927111848-56163afc0107?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroAbstract:
    "https://images.pexels.com/photos/16442356/pexels-photo-16442356.jpeg?auto=compress&cs=tinysrgb&w=1600",
  neuralAbstract:
    "https://images.unsplash.com/photo-1719550371336-7bb64b5cacfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  clinicInterior:
    "https://images.unsplash.com/photo-1648775507324-b48dd3791fa5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  clinicSoft:
    "https://images.unsplash.com/photo-1733976586565-76c2707eed9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  softNeutral:
    "https://images.unsplash.com/photo-1644481361524-5af470330623?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  portrait: "/photos/portrait.jpg",
  aboutSecond: "/photos/about-second.jpg",
  doctorDesk: "/photos/doctor-desk.jpg",
  action: "/photos/action.jpg",
  speaking: "/photos/speaking.jpg",
  clinicReal: "/photos/clinic-1.jpg",
  clinicReal2: "/photos/clinic-2.jpg",
  clinicReal3: "/photos/clinic-3.jpg",
  clinicReal4: "/photos/clinic-4.jpg",
  clinicReal5: "/photos/clinic-5.jpg",
  clinicReal6: "/photos/clinic-6.jpg",
  gen: {
    botanical: "/generated/areas_botanical.jpg",
    soundwave: "/generated/areas_soundwave.jpg",
    birds: "/generated/areas_birds.jpg",
    water: "/generated/areas_water.jpg",
    forest: "/generated/areas_forest.jpg",
    neuro: "/generated/areas_neuro.jpg",
    visionBg: "/generated/vision_bg.jpg",
    ctaBg: "/generated/cta_bg.jpg",
    heroAccent: "/generated/hero_accent.png",
    diagnosis: "/generated/svc_diagnosis.jpg",
    therapies: "/generated/svc_therapies.jpg",
    vns: "/generated/svc_vns.jpg",
    eeg: "/generated/svc_eeg.jpg",
    visits: "/generated/svc_visits.jpg",
    prevention: "/generated/svc_prevention.jpg",
    diagnosisDark: "/generated/svc_diagnosis_dark.jpg",
    interventionalDark: "/generated/svc_interventional_dark.jpg",
    vnsDark: "/generated/svc_vns_dark.jpg",
    eegDark: "/generated/svc_eeg_dark.jpg",
    visitsDark: "/generated/svc_visits_dark.jpg",
    preventionDark: "/generated/svc_prevention_dark.jpg",
    visionDarkNeuro: "/generated/vision_dark_neuro.jpg",
    heroHome: "/generated/hero_home.jpg",
    heroConditions: "/generated/hero_conditions.jpg",
    // Tropical botanical gold line-art — active site theme
    tropDiagnosis: "/generated/v_svc_diagnosis_r.webp",
    tropInterventional: "/generated/v_svc_interventional_r.webp",
    tropVns: "/generated/v_svc_vns.webp",
    tropEeg: "/generated/v_svc_eeg.webp",
    tropVisits: "/generated/v_svc_visits.jpg",
    tropPrevention: "/generated/v_svc_prevention.jpg",
  },
  office: {
    door: "/photos/office/door.jpg",
    reception: "/photos/office/reception.jpg",
    waiting: "/photos/office/waiting.jpg",
    exam: "/photos/office/exam.jpg",
    card: "/photos/office/card.jpg",
    lounge: "/photos/office/lounge.jpg",
    consult: "/photos/office/consult.jpg",
  },
};

export const LOGO = {
  mark: "/brand/logo-real-gold.webp",
  schema: "/brand/logo-real-gold.png",
  markLight: "/brand/logo-real-light.png",
};

export const FLORAL = {
  corner: "/floral/corner.png",
  line: "/floral/line.png",
  bloom: "/floral/bloom.png",
};

// Training & affiliations shown on the "logo wall". `logo` is optional — drop a file into
// /public/logos and reference it here once usage rights are confirmed; otherwise an emblem shows.
export const affiliations = [
  {
    id: "eginition",
    icon: "Landmark",
    logo: "/logos/uoa.webp",
    name: { el: "Αιγινήτειο — ΕΚΠΑ", en: "Eginition — Univ. of Athens" },
    sub: { el: "Α΄ Νευρολογική Κλινική · Ιατρείο Επιληψίας", en: "1st Neurology Clinic · Epilepsy Unit" },
  },
  {
    id: "epicare",
    icon: "Globe",
    logo: "/logos/epicare.png",
    name: { el: "Epicare · Salzburg", en: "Epicare · Salzburg" },
    sub: { el: "Ευρωπαϊκό Κέντρο Αναφοράς Επιληψίας", en: "European Reference Network for Epilepsy" },
  },
  {
    id: "ilae",
    icon: "Award",
    logo: "/logos/ilae.png",
    name: { el: "ILAE", en: "ILAE" },
    sub: { el: "Πιστοποίηση Επιληπτολογίας & Video-EEG", en: "Epileptology & Video-EEG certification" },
  },
  {
    id: "einstein",
    icon: "GraduationCap",
    logo: "/logos/einstein.png",
    name: { el: "Albert Einstein", en: "Albert Einstein" },
    sub: { el: "College of Medicine, ΗΠΑ · Michael Foundation", en: "College of Medicine, USA · Michael Foundation" },
  },
  {
    id: "affidea",
    icon: "BrainCircuit",
    logo: "/logos/affidea.svg",
    name: { el: "Affidea NeuraCare", en: "Affidea NeuraCare" },
    sub: { el: "Υπεύθυνη Εργαστηρίου ΗΕΓ", en: "Head of the EEG Laboratory" },
  },
  {
    id: "patras",
    icon: "GraduationCap",
    logo: "/logos/patras.png",
    name: { el: "Πανεπιστήμιο Πατρών", en: "University of Patras" },
    sub: { el: "Πτυχίο Ιατρικής", en: "Medical Degree" },
  },
  {
    id: "ean",
    icon: "Globe",
    logo: "/logos/ean.png",
    name: { el: "European Academy of Neurology", en: "European Academy of Neurology" },
    sub: { el: "Μέλος (EAN)", en: "Member (EAN)" },
  },
];

// Credentials shown as small logos in the hero badge.
export const heroCredentials = [
  { id: "epicare", logo: "/logos/epicare.png", label: "Epicare" },
  { id: "ilae", logo: "/logos/ilae.png", label: "ILAE" },
  { id: "einstein", logo: "/logos/einstein.png", label: "Albert Einstein" },
];
